import { render, staticRenderFns } from "./OrganisationSelect.vue?vue&type=template&id=14b7fef3&scoped=true&"
import script from "./OrganisationSelect.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSelect.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationSelect.vue?vue&type=style&index=0&id=14b7fef3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b7fef3",
  null
  
)

export default component.exports